module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_7042.0b626346.png";